import { View, Text, TouchableOpacity, Linking, Image, Platform } from "react-native";
import React from "react";
import { ScrollView } from "react-native";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import i18n from "../../../../locales/i18n";
import StandardNavigation from "../../../../components/navigation/StandardNavigation";
import { useLocalSearchParams } from "expo-router";
import WebContactScreen from "../../../../components/web/WebContactScreen";
import Animated, { FadeInDown } from "react-native-reanimated";

const ContactPage = () => {
  const { upgrade } = useLocalSearchParams();
  const customTitle = (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <Text
          style={{
            fontFamily: "kawkabBold",
            color: "white",
            fontSize: 18,
          }}
        >
          {i18n.t("contactus")}
        </Text>
      </View>
    </View>
  );

  // Social media data with existing assets
  const socialMedia = [
    {
      name: i18n.t("facebook"),
      icon: require("../../../../assets/social/facebook.png"),
      action: () =>
        Linking.openURL(
          "https://www.facebook.com/profile.php?id=61575224393561#"
        ),
    },
    {
      name: i18n.t("instagram"),
      icon: require("../../../../assets/social/instagram.png"),
      action: () => Linking.openURL("https://www.instagram.com/khdame_app"),
    },
    {
      name: i18n.t("website"),
      icon: require("../../../../assets/social/web.png"),
      action: () => Linking.openURL("https://khdame.com"),
    },
    {
      name: i18n.t("call"),
      icon: require("../../../../assets/social/phone.png"),
      action: () => Linking.openURL("tel:0540849366"),
    },
    {
      name: i18n.t("emailContact"),
      icon: require("../../../../assets/social/mail.png"),
      action: () => Linking.openURL("mailto:khdame.contact@gmail.com"),
    },
  ];

  // Render web version on web platform
  if (Platform.OS === "web") {
    return <WebContactScreen />;
  }

  return (
    <View style={{ flex: 1, backgroundColor: "#f5f5f5" }}>
      {/* Standard Navigation */}
      <StandardNavigation
        customTitle={customTitle}
        showBackButton={true}
        showMenuButton={true}
        showLogo={true}
      />

      <ScrollView style={{ flex: 1 }} className="p-4">
        {/* Upgrade Banner - Show when coming from limits page */}
        {upgrade === "true" && (
          <Animated.View
            entering={FadeInDown.duration(400).delay(100)}
            style={{
              backgroundColor: "#3B82F6",
              borderRadius: 12,
              padding: 20,
              marginBottom: 20,
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.15,
              shadowRadius: 6,
              elevation: 4,
            }}
          >
            <Text
              style={{
                fontFamily: "kawkabReg",
                fontSize: 15,
                color: "white",
                lineHeight: 22,
                opacity: 0.95,
              }}
            >
              {i18n.t("contactUsForUpgrade") ||
                "Contact us through any of the channels below to unlock unlimited access to all features!"}
            </Text>
          </Animated.View>
        )}

        {/* Contact Cards */}
        <View style={{ marginTop: 10 }}>
          {socialMedia.map((item, index) => (
            <Animated.View
              key={index}
              entering={FadeInDown.duration(400).delay(index * 100 + (upgrade === "true" ? 200 : 100))}
            >
              <TouchableOpacity
              onPress={item.action}
              style={{
                backgroundColor: "#E3E3E3",
                borderRadius: 12,
                marginBottom: 12,
                paddingHorizontal: 20,
                paddingVertical: 16,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 4,
                elevation: 3,
              }}
            >
              {/* Icon */}
              <Image
                source={item.icon}
                style={{ width: 40, height: 40 }}
                resizeMode="contain"
              />

              {/* Text */}
              <Text
                style={{
                  fontFamily: "kawkabBold",
                  fontSize: 18,
                  color: "#333",
                  flex: 1,
                  textAlign: "center",
                }}
              >
                {item.name}
              </Text>

              {/* Arrow */}
              <MaterialIcons name="arrow-forward-ios" size={20} color="#666" />
            </TouchableOpacity>
            </Animated.View>
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

export default ContactPage;
